import axios from 'axios';

import { SERVICES_URL } from '@/lib/constants';

/**
 * Client du web service « services » (IBAN, adresses, lieux de naissance).
 *
 * Envoie les cookies : le cookie HttpOnly `auth_token` est géré par le serveur.
 */
export const requestServices = axios.create({
    baseURL: SERVICES_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
